import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { VendorModel } from 'src/app/model/vendor-model';
import { VMS_USER_MASTER } from 'src/app/model/user-registration-model';
import { VendorService } from 'src/app/services/vendor.service';
import { LoginService } from 'src/app/services/User.service';


@Component({
  selector: 'app-po-header',
  templateUrl: './po-header.component.html',
  styleUrls: ['./po-header.component.css']
})

export class PoHeaderComponent implements OnInit {
  vendorMasterList: VendorModel[] = [];
  TempvendorMasterList: VendorModel[] = [];
  userRegistrationModel: VMS_USER_MASTER = new VMS_USER_MASTER();
  userRegistrationList: VMS_USER_MASTER[] = [];
  Flag: any = '';
  p: any;

  constructor(private toastr: ToastrService, private vendorSer: VendorService, private UserSer: LoginService) {

  }

  ngOnInit() {
    this.GetVendorMaster().
      then(res => this.GetUserList());
  }

  EditUser(item: VMS_USER_MASTER) {
    this.vendorMasterList = this.TempvendorMasterList;
    this.userRegistrationModel = new VMS_USER_MASTER();
    this.userRegistrationModel.USER_PASSWORD = item.USER_PASSWORD;
    this.userRegistrationModel.USER_CONFIRM_PASSWORD = item.USER_PASSWORD;
    this.userRegistrationModel.USER_NAME = item.USER_NAME;
    this.userRegistrationModel.USER_SEQ = item.USER_SEQ;
    this.userRegistrationModel.USER_ROLE = item.USER_ROLE;

  }
  DeactivateUser(index: number, flag) {
    debugger;
    var Usermodel = new VMS_USER_MASTER();
    var msg = "";
    var succesmsg = "";
    Usermodel = this.userRegistrationList[index];
    Usermodel.USER_MODIFIED_BY = sessionStorage.getItem("UserName");
    if (flag == 'Active') {
      Usermodel.USER_ACTIVE = true;
      msg = "Do you want to activate " + Usermodel.USER_NAME + " user!";
      succesmsg = "User has been successfully activated successfully";
    }
    else if (flag == 'InActive') {
      Usermodel.USER_ACTIVE = false;
      msg = "Do you want to Deactivate " + Usermodel.USER_NAME + " user!";
      succesmsg = "User has been successfully Deactivated successfully";
    }
    if (confirm(msg)) {
      this.userRegistrationModel.USER_MODIFIED_BY = sessionStorage.getItem("UserName");
      this.UserSer.DeactivateUserRecord(Usermodel).subscribe(
        res => {
          if (res.StatusCode == 200) {
            this.toastr.success(succesmsg);
            this.userRegistrationModel = new VMS_USER_MASTER();
            this.GetVendorMaster().
              then(res => this.GetUserList());
          }
          else {
            this.toastr.error(res.Message)
          }
        },
        error => {
          console.log(error);
          console.error();
        }
      );
    }
  }

  GetVendorMaster() {
    let promise = new Promise((resolve, reject) => {
      // let apiURL = `${this.apiRoot}?term=${term}&media=music&limit=20`;
      this.vendorSer.GetAllVendorMaster().toPromise()
        .then(
          res => { // Success
            this.vendorMasterList = res.Data[0];
            this.TempvendorMasterList = res.Data[1];
            resolve('success');
          }
        );
    });
    return promise;
  }

  GetUserList() {
    this.UserSer.GetAllUserList().subscribe(
      res => {
        this.userRegistrationList = res.Data;
        this.userRegistrationList.forEach(element => {
          if (element.USER_ROLE == 'VENDOR') {

            if (this.TempvendorMasterList.filter(x => x.VM_NO == element.USER_NAME)[0] == undefined) {
              console.log('undefined value');
            }
            else {
              element.NAME = this.TempvendorMasterList.filter(x => x.VM_NO == element.USER_NAME)[0].VM_NAME;
            }
            //  if(this.TempvendorMasterList.find(x=>x.VM_NO==element.USER_NAME)!=undefined){
            //   element.NAME=this.TempvendorMasterList.find(x=>x.VM_NO==element.USER_NAME).VM_NAME;
            //  }

          }
        });
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }
  validations() {
    if (this.userRegistrationModel.USER_NAME == undefined || this.userRegistrationModel.USER_NAME == '') {
      this.toastr.warning("Please select Vendor Name");
      return false;

    }
    else if (this.userRegistrationModel.USER_PASSWORD == undefined || this.userRegistrationModel.USER_PASSWORD == '') {
      this.toastr.warning("Please enter password");
      return false;

    }
    else if (this.userRegistrationModel.USER_CONFIRM_PASSWORD == undefined || this.userRegistrationModel.USER_CONFIRM_PASSWORD == '') {
      this.toastr.warning("Please enter confirm password");
      return false;

    }
    else if (this.userRegistrationModel.USER_PASSWORD != this.userRegistrationModel.USER_CONFIRM_PASSWORD) {
      this.toastr.warning("password and confirm password does not match");
      return false;

    } else {
      return true;
    }

  }


  SaveUser() {
    if (this.validations()) {
      debugger;
      if (this.userRegistrationModel.USER_SEQ != undefined || this.userRegistrationModel.USER_SEQ > 0) {
        this.userRegistrationModel.USER_MODIFIED_BY = sessionStorage.getItem("UserName");
        this.UserSer.UpdateUserRecord(this.userRegistrationModel).subscribe(
          data => {

            if (data.StatusCode == 200) {
              this.toastr.success(data.Message);
              this.userRegistrationModel = new VMS_USER_MASTER();
              this.GetVendorMaster().
                then(res => this.GetUserList());
            }
            else {
              this.toastr.error(data.Message)
            }
          },
          error => {
            this.toastr.error(error.error.message)
            console.log(error.error.message);
            console.error();
          }
        );
      } else {
        this.userRegistrationModel.USER_ROLE = "VENDOR";
        this.userRegistrationModel.USER_CREATED_BY = sessionStorage.getItem("UserName");
        this.UserSer.SaveUserRecord(this.userRegistrationModel).subscribe(
          data => {
            if (data.StatusCode == 200) {
              this.toastr.success(data.Message);
              this.userRegistrationModel = new VMS_USER_MASTER();
              this.GetVendorMaster().
                then(res => this.GetUserList());
            }
            else {
              this.toastr.error(data.Message)
            }
          },
          error => {
            this.toastr.error(error.error.message)
            console.log(error.error.message);
            console.error();
          }
        );
      }
    }
  }


  sortDropDown(collection:any[]=[])
  {
    return collection.sort((a, b) => (a.VM_NAME < b.VM_NAME) ? -1 : 1);
  }
  sortUserList(collection:any[]=[])
  {
    return collection.sort((a, b) => (a.NAME < b.NAME) ? -1 : 1);
  }

}
